module.exports = __webpack_public_path__ + "static/media/expert (1).18876c42.png";